import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Button from '../common/Button';

const Countdown = ({ onComplete }) => {
  const [count, setCount] = useState(3);
  const [isSkipped, setIsSkipped] = useState(false);

  useEffect(() => {
    if (isSkipped) {
      onComplete();
      return;
    }

    if (count > 0) {
      const timer = setTimeout(() => setCount(count - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      const timer = setTimeout(onComplete, 1000);
      return () => clearTimeout(timer);
    }
  }, [count, onComplete, isSkipped]);

  const handleSkip = () => {
    setIsSkipped(true);
  };

  return (
    <div className="fixed inset-0 bg-gradient-to-br from-pink-100 via-purple-100 to-blue-100 flex flex-col items-center justify-center z-[150] gap-8">
      {/* 背景裝飾 - 與主頁一致 */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {Array.from({ length: 10 }).map((_, i) => (
          <div
            key={i}
            className="absolute bg-white/30 rounded-full blur-sm animate-float"
            style={{
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 50 + 20}px`,
              height: `${Math.random() * 50 + 20}px`,
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${Math.random() * 10 + 10}s`
            }}
          />
        ))}
      </div>

      {/* 倒數數字 */}
      <AnimatePresence mode="wait">
        {count > 0 ? (
          <motion.div
            key={count}
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 1.5, opacity: 0 }}
            className="w-32 h-32 bg-gradient-to-br from-pink-500 to-purple-600 rounded-full flex items-center justify-center text-white text-6xl font-bold shadow-2xl relative z-10"
          >
            {count}
          </motion.div>
        ) : (
          <motion.div
            key="start"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 1.5, opacity: 0 }}
            className="bg-gradient-to-r from-green-500 to-blue-500 text-white px-12 py-6 rounded-3xl text-3xl font-bold shadow-2xl relative z-10"
          >
            開始! 🎮
          </motion.div>
        )}
      </AnimatePresence>

      {/* 跳過按鈕 */}
      {count > 0 && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="relative z-10"
        >
          <Button
            onClick={handleSkip}
            variant="secondary"
            className="shadow-xl hover:scale-110 transition-transform"
          >
            ⏭️ 跳過倒數
          </Button>
        </motion.div>
      )}
    </div>
  );
};

export default Countdown;